const state={piece:null,material:null,scale:null,setting:null,ptype:null,budget:null,timeline:null,who:null};
const REQ=[['piece','Piece','piece'],['material','Material','material'],['scale','Scale','scale'],['setting','Setting','place'],['ptype','Project type','place']];
const WAN='971555048125';
const t0=Date.now();

document.addEventListener('click',e=>{
  const b=e.target.closest('[data-v]');if(!b)return;
  const g=b.dataset.g||b.closest('[data-g]')?.dataset.g;if(!g)return;
  const on=b.classList.contains('on');
  document.querySelectorAll('[data-g="'+g+'"] [data-v], [data-v][data-g="'+g+'"]').forEach(x=>x.classList.remove('on'));
  if(!on){b.classList.add('on');state[g]=b.dataset.v}else{state[g]=null}
  b.closest('.step')?.classList.remove('miss');
  clearMiss();update();
});
document.getElementById('fname').addEventListener('input',e=>{e.target.classList.remove('miss');clearMiss();update()});

function clean(s,max){return s.replace(/[\u0000-\u001F\u007F]/g,'').slice(0,max).trim()}
function setLine(id,val,fb){const el=document.getElementById('b-'+id);
  if(val){el.textContent=val.split(' — ')[0];el.classList.remove('empty')}else{el.textContent=fb;el.classList.add('empty')}}
function update(){
  setLine('piece',state.piece,'Not selected');setLine('material',state.material,'Not selected');
  setLine('scale',state.scale,'Not selected');setLine('setting',state.setting,'Not selected');
  setLine('ptype',state.ptype,'Not selected');setLine('budget',state.budget,'Optional');setLine('timeline',state.timeline,'Optional');
  const name=clean(document.getElementById('fname').value,80);
  const done=REQ.filter(r=>state[r[0]]).length+(name?1:0);
  document.getElementById('pfill').style.width=(done/6*100)+'%';
  const t=done+' of 6 required answered';
  document.getElementById('pcount').textContent=t;
  document.getElementById('mtxt').textContent=done+' of 6 answered';
}
function clearMiss(){document.getElementById('missmsg').classList.remove('show')}
function missing(){
  const m=REQ.filter(r=>!state[r[0]]).map(r=>({label:r[1],step:r[2]}));
  if(!clean(document.getElementById('fname').value,80))m.push({label:'Your name',step:'details'});
  return m;
}
function guide(m){
  const box=document.getElementById('missmsg');
  box.innerHTML='Almost there — still needed: <b>'+m.map(x=>x.label).join(', ')+'</b>';
  box.classList.add('show');
  m.forEach(x=>{
    const st=document.querySelector('[data-step="'+x.step+'"]');
    st.classList.remove('miss');void st.offsetWidth;st.classList.add('miss');
    if(x.label==='Your name')document.getElementById('fname').classList.add('miss');
  });
  document.querySelector('[data-step="'+m[0].step+'"]').scrollIntoView({behavior:'smooth',block:'center'});
}
function compose(){
  const name=clean(document.getElementById('fname').value,80);
  const ref=clean(document.getElementById('fref').value,300);
  const notes=clean(document.getElementById('fnotes').value,500);
  let m="Hello 1-OPH — I'd like to commission a piece.\n";
  m+="\n• Piece: "+state.piece+"\n• Material: "+state.material+"\n• Scale: "+state.scale;
  m+="\n• Setting: "+state.setting+"\n• Project type: "+state.ptype;
  if(state.budget)m+="\n• Budget: "+state.budget;
  if(state.timeline)m+="\n• Timeline: "+state.timeline;
  if(state.who)m+="\n• I am a: "+state.who;
  if(ref)m+="\n• Reference: "+ref;
  if(notes)m+="\n• Notes: "+notes;
  m+="\n\n— "+name;
  return m;
}
function ok(){
  if(document.getElementById('fweb').value)return false;      /* honeypot */
  if(Date.now()-t0<3000)return false;                          /* time gate */
  const m=missing();
  if(m.length){guide(m);return false}
  return true;
}
function sendWA(){if(ok())location.href='https://wa.me/'+WAN+'?text='+encodeURIComponent(compose())}
function sendMail(){if(ok())location.href='mailto:hello@1oph.com?subject='+encodeURIComponent('Commission Enquiry — 1-OPH')+'&body='+encodeURIComponent(compose())}
document.getElementById('send').addEventListener('click',sendWA);
document.getElementById('msend').addEventListener('click',sendWA);
document.getElementById('sendmail').addEventListener('click',sendMail);

const io=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}}),{threshold:.07});
document.querySelectorAll('.rv').forEach(el=>io.observe(el));
const mio=new IntersectionObserver(es=>es.forEach(x=>document.getElementById('mbar').classList.toggle('show',x.isIntersecting)),{threshold:0});
mio.observe(document.getElementById('configurator'));